import {
  ADDRESS
} from './address'
import {
  get,
  post
} from "./http"
import axios from 'axios'
export default {
  // H5获取手机验证码
  getCode(params) {
    axios.defaults.withCredentials = false
    let url = ADDRESS.address1 + '/app/user/getNumForUser'
    return post(url, params)
  },
  // H5手机号+验证码登录
  phoneLogin(params) {
    axios.defaults.withCredentials = false
    let url = ADDRESS.address1 + '/app/user/PhoneLogin'
    return post(url, params)
  },
  // PC获取用户信息
  getUserInfo() {
    axios.defaults.withCredentials = true
    let url = ADDRESS.address3 + '/ajax/user/get-login-info-new'
    return post(url)
  },
  // 根据房间号获取用户信息
  getUserInfoByRoomNum(params) {
    axios.defaults.withCredentials = false
    let url = ADDRESS.address2 + '/h5-common/f-get-room-info'
    return get(url, params)
  },
  // PC密码登录
  getLoginBypwd(params) {
    axios.defaults.withCredentials = true
    let url = ADDRESS.address3 + '/ajax/user/login'
    return post(url, params)
  },
  // PC获取手机验证码
  sendCodefromPC(params) {
    axios.defaults.withCredentials = false
    let url = ADDRESS.address2 + '/user/send-phone-code'
    return post(url, params)
  },
  // PC手机验证码登录(沿用联合会员的)
  codeLoginfromPC(params) {
    axios.defaults.withCredentials = true
    let url = ADDRESS.address3 + '/ajax/user/phone-login'
    return post(url, params)
  },
  // PC退出登录
  loginOutfromPC() {
    axios.defaults.withCredentials = true
    let url = ADDRESS.address3 + '/ajax/user/login-out'
    return post(url)
  },
  // 微博--code换取access_token（跨域、不用、会删）
  getAccessTokenBySina(params) {
    axios.defaults.withCredentials = false
    let url = ADDRESS.address4 + '/oauth2/access_token'
    return get(url, params)
  },
  // 三方登录(在回调页用)
  thirdLoginAll(params) {
    axios.defaults.withCredentials = true
    let url = ADDRESS.address3 + '/ajax/user/third-login-all'
    return get(url, params)
  },
  // 绑定手机号
  gotoBindtel(params) {
    axios.defaults.withCredentials = true
    let url = ADDRESS.address2 + '/third-login/pc-bind-phone'
    return post(url, params)
  },
  // 使用token登录
  loginByToken(params){
    axios.defaults.withCredentials = true
    let url = ADDRESS.address2+'/third-login/pc-login-by-token'
    return get(url, params)
  },
  // 账号确认
  getCountInfo(params){
    axios.defaults.withCredentials = false
    let url = ADDRESS.address2 + '/third-login/user-accounts-info'
    return post(url, params)
  },
  // 账号合并
  mergeCount(params){
    axios.defaults.withCredentials = false
    let url = ADDRESS.address2 + '/third-login/user-number-merge'
    return post(url, params)
  },
	// 获取验证码优化 2023.06
	getReqId(params){
		let url = ADDRESS.address2 + '/user/get-req-id'
		return axios.post(url, params
			// ,{
			// 	headers: {
			// 		'Req-Token': '123'
			// 	}
			// }
		)
	},
}